// State màn Giao may ảnh. Kết quả kiểm tra lưu theo TÊN LÔ (checks), không gắn vào dòng:
// xoá/sửa dòng thì trạng thái trùng, hợp lệ... tự tính lại từ rows + checks (xem getRowStatus).

export const normalizeBatchName = (name) => `${name || ''}`.trim().toUpperCase()

export const ROW_STATUS = {
    DECODING: 'decoding',     // đang thu nhỏ ảnh / đọc QR
    NO_QR: 'no_qr',           // không đọc được QR → cần nhập tay
    NEED_PICK: 'need_pick',   // ảnh có nhiều mã → chọn 1
    DUPLICATE: 'duplicate',   // trùng tên lô với dòng chụp trước
    CHECKING: 'checking',     // đang kiểm tra với server
    OK: 'ok',
    ERROR: 'error',
}

export const ISSUE_STATUSES = [ROW_STATUS.NO_QR, ROW_STATUS.NEED_PICK, ROW_STATUS.DUPLICATE, ROW_STATUS.ERROR]

export const initialState = {
    rows: [],          // { key, seq, file, previewUrl, codes[], name, source: 'qr'|'manual'|'edited', decoding, autoFocus }; dòng nhập tay: file = null
    checks: {},        // name -> { pending, reqId } | kết quả validate { valid, code, message, sku, items_count, ... }
    partner: '',
    filter: 'all',     // 'all' | 'issues' | 'ok'
    search: '',
    jumpKey: null,     // key của dòng cần xử lý vừa nhảy tới bằng link "⚠ n dòng cần xử lý"
    submitting: false,
    uploadPercent: 0,
    banner: null,      // { title, message } — lỗi giao may
    result: null,      // handover trả về khi giao thành công
}

export const ACTIONS = {
    ADD_ROW: 'ADD_ROW',
    DECODED: 'DECODED',
    PICK_CODE: 'PICK_CODE',
    SET_NAME: 'SET_NAME',
    REMOVE_ROW: 'REMOVE_ROW',
    CHECK_START: 'CHECK_START',
    CHECK_DONE: 'CHECK_DONE',
    CHECK_FAILED: 'CHECK_FAILED',
    CHECKS_SET: 'CHECKS_SET',
    CHECKS_CLEAR: 'CHECKS_CLEAR',
    SET_PARTNER: 'SET_PARTNER',
    SET_FILTER: 'SET_FILTER',
    SET_SEARCH: 'SET_SEARCH',
    JUMP_TO: 'JUMP_TO',
    SUBMIT_START: 'SUBMIT_START',
    UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',
    SUBMIT_FAILED: 'SUBMIT_FAILED',
    SUBMIT_OK: 'SUBMIT_OK',
    DISMISS_BANNER: 'DISMISS_BANNER',
    RESET: 'RESET',
}

const updateRow = (rows, key, patch) => rows.map(row => (row.key === key ? { ...row, ...patch } : row))

const applyCheckResults = (checks, items, reqId) => {
    const next = { ...checks }

    items.forEach((item) => {
        const name = normalizeBatchName(item.name)
        const current = next[name]

        // Bỏ kết quả của request cũ: tên này đã được gửi kiểm tra lại sau đó, hoặc đã bị xoá khỏi checks (Kiểm tra lại)
        if (reqId && !(current && current.pending && current.reqId === reqId)) return

        next[name] = item
    })

    return next
}

export const handoverReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.ADD_ROW:
            // manual: dòng thêm bằng nút "Nhập tay" → không có ảnh (file/previewUrl null), mở sẵn ô gõ tên lô
            return {
                ...state,
                rows: [...state.rows, {
                    key: action.key,
                    seq: state.rows.length + 1,
                    file: action.file,
                    previewUrl: action.previewUrl,
                    codes: [],
                    name: '',
                    source: action.manual ? 'manual' : 'qr',
                    decoding: !action.manual,
                    autoFocus: !!action.manual,
                }],
            }

        case ACTIONS.DECODED: {
            const codes = [...new Set((action.codes || []).map(normalizeBatchName).filter(Boolean))]

            return {
                ...state,
                rows: updateRow(state.rows, action.key, {
                    decoding: false,
                    codes,
                    name: codes.length === 1 ? codes[0] : '',
                    source: 'qr',
                }),
            }
        }

        case ACTIONS.PICK_CODE:
            return { ...state, rows: updateRow(state.rows, action.key, { name: normalizeBatchName(action.name), source: 'qr' }) }

        case ACTIONS.SET_NAME: {
            const row = state.rows.find(r => r.key === action.key)
            if (!row) return state
            const name = normalizeBatchName(action.name)
            // Tên khác mã đọc được từ QR → sửa tay; ảnh không có QR → nhập tay
            const source = row.codes.length ? (row.codes.includes(name) ? 'qr' : 'edited') : 'manual'

            return { ...state, rows: updateRow(state.rows, action.key, { name, source, autoFocus: false }) }
        }

        case ACTIONS.REMOVE_ROW:
            // Đánh lại # liên tục theo vị trí để khớp chồng lệnh may trên tay (#1, #3 → #1, #2)
            return {
                ...state,
                rows: state.rows
                    .filter(row => row.key !== action.key)
                    .map((row, index) => (row.seq === index + 1 ? row : { ...row, seq: index + 1 })),
            }

        case ACTIONS.CHECK_START: {
            const checks = { ...state.checks }
            action.names.forEach((name) => {
                checks[name] = { pending: true, reqId: action.reqId }
            })

            return { ...state, checks }
        }

        case ACTIONS.CHECK_DONE:
            return { ...state, checks: applyCheckResults(state.checks, action.items, action.reqId) }

        case ACTIONS.CHECK_FAILED: {
            // Lỗi mạng khi kiểm tra: đánh dấu lỗi (không tự gửi lại liên tục); người dùng bấm "Kiểm tra lại"
            const checks = { ...state.checks }
            action.names.forEach((name) => {
                if (checks[name] && checks[name].reqId === action.reqId) {
                    checks[name] = {
                        name,
                        valid: false,
                        code: 'check_failed',
                        message: action.message || 'Không kiểm tra được lô. Bấm "Kiểm tra lại".',
                    }
                }
            })

            return { ...state, checks }
        }

        case ACTIONS.CHECKS_SET:
            // Kết quả server trả lúc bấm Giao may (lô vừa bị đổi trạng thái) → đánh dấu atSubmit để hiện "Vừa được giao..."
            return { ...state, checks: applyCheckResults(state.checks, action.items.map(item => ({ ...item, atSubmit: !!action.atSubmit }))) }

        case ACTIONS.CHECKS_CLEAR:
            return { ...state, checks: {} }

        case ACTIONS.SET_PARTNER:
            return { ...state, partner: action.partner || '' }

        case ACTIONS.SET_FILTER:
            return { ...state, filter: action.filter, jumpKey: null }

        case ACTIONS.SET_SEARCH:
            return { ...state, search: action.search }

        case ACTIONS.JUMP_TO:
            return { ...state, jumpKey: action.key }

        case ACTIONS.SUBMIT_START:
            return { ...state, submitting: true, uploadPercent: 0, banner: null }

        case ACTIONS.UPLOAD_PROGRESS:
            return { ...state, uploadPercent: action.percent }

        case ACTIONS.SUBMIT_FAILED:
            return { ...state, submitting: false, uploadPercent: 0, banner: { title: action.title || 'Chưa giao lô nào.', message: action.message } }

        case ACTIONS.SUBMIT_OK:
            // Giao xong thì bỏ chọn đối tác: lượt sau phải chọn lại, tránh giao nhầm cho đối tác cũ
            return { ...state, submitting: false, uploadPercent: 100, banner: null, result: action.handover, partner: '' }

        case ACTIONS.DISMISS_BANNER:
            return { ...state, banner: null }

        case ACTIONS.RESET:
            return { ...initialState }

        default:
            return state
    }
}

// Trạng thái hiển thị của một dòng, tính từ rows + checks
export const getRowStatus = (row, rows, checks) => {
    if (row.decoding) return ROW_STATUS.DECODING
    if (!row.name) return row.codes.length > 1 ? ROW_STATUS.NEED_PICK : ROW_STATUS.NO_QR

    const first = rows.find(r => r.name === row.name)
    if (first && first.key !== row.key) return ROW_STATUS.DUPLICATE

    const check = checks[row.name]
    if (!check || check.pending) return ROW_STATUS.CHECKING

    return check.valid ? ROW_STATUS.OK : ROW_STATUS.ERROR
}

// Các tên cần gửi kiểm tra: tên của dòng + mọi mã của dòng nhiều mã (để gợi ý mã hợp lệ)
export const getNamesToCheck = (rows, checks) => {
    const names = new Set()

    rows.forEach((row) => {
        if (row.decoding) return
        if (row.name) names.add(row.name)
        if (!row.name && row.codes.length > 1) row.codes.forEach(code => names.add(code))
    })

    return [...names].filter(name => !checks[name])
}
